/*
 *	Entità che rappresenta la password
 *
 *	Questa classe si occupat della gestione della password in sé
 *  	e  della comparazione con altre password
 * 
 *	Le chiamate al BE associate al cambio password sono nei service associati
 *		change-password.service.ts
 *
 */ 


import {Utilities as U} from '../../shared/utilities/utilities.model';
import {Observable} from 'rxjs/Observable';
import {DateUtilities} from '../../shared/utilities/date-utilities.model';

declare const require: any;

export class ChangePasswordParamsModel {

	bcrypt = require('bcryptjs');

	// Questa è la password corrente
	password: string;
	last_password_changed_at: string;
	last_used_passwords: string[];

	
	// Semplice controllo base - serve al il cambio password
	static isEqualPassword(currentPassword: string, newPassword: string): boolean {
		return currentPassword === newPassword;
	}

	static getMinLength(num: number): number {
		return num ? num : MIN_NUMBER_CHAR_PASSWORD;
	}

	constructor(model?: any) {
		if (model) {
			this.password = model.password;
			this.last_password_changed_at = model.last_password_changed_at;
			this.last_used_passwords = model.last_used_passwords;
		}
	}

	isCurrentPassword(val: string): Promise<boolean> {
		console.log(val);
		console.log(this.password);
		return this.bcrypt.compare(this.password, val);
	}
	
	canChangePassword(): boolean {

		// TODO
		// Da eliminare - viene gestito lato OAM
		return true;

		// const lpca: Date = DateUtilities.getDateUTCFromString(this.last_password_changed_at);
		// lpca.setDate(lpca.getDate() + 1);
		// return DateUtilities.compareDateIsBefore(lpca, new Date())
		// 	|| U.isEmpty(this.last_used_passwords)
		// 	|| this.last_used_passwords.length <= 1;
	}

	// Controlla se la password è stata usata negli ultimi 10 cambi password
	async isUsedPassword(newPassword: string): Promise<boolean> {

		const res = await Promise.all( 
			this.last_used_passwords.map(async x => {
				return await this.bcrypt.compare(newPassword, x)
			})
		);

		// Errore se almeno una password risulta compatibile
		if (res.some(x => x))
			return true;

		return false;
	}
}


const MIN_NUMBER_CHAR_PASSWORD = 10;
